(function () {
  // Limit repair to desktop Chromium. Android, Apple
  // Safari, WKWebView, all iOS browsers, and touch-mode iPads are untouched.
  function canRepairHls() {
    var n = window.navigator || {}, ua = n.userAgent || '';
    return /(?:Chrome|Chromium)\/\d+/i.test(ua) &&
      !/Android|iPad|iPhone|iPod/i.test(ua) &&
      !(/Mac/i.test(n.platform || '') && n.maxTouchPoints > 1);
  }

  if (!canRepairHls()) return;

  function bindInitialHls(player) {
    if (!canRepairHls() || !player || player._klaroHlsInitV1 || player._klaroHlsInitPending ||
        player.isDisposed() || typeof player.ready !== 'function') return;
    var initial = player.currentSource();
    if (!initial || !initial.src) return;
    var initialSrc = initial.src, initialType = initial.type;
    // Deduplicate pending initialization; only a real binding is marked done.
    player._klaroHlsInitPending = true;
    player.ready(function () {
      player._klaroHlsInitPending = false;
      try {
      if (player.isDisposed()) return;
      var source = player.currentSource();
      if (!source || !source.src) return;
      var type = (source.type || '').toLowerCase();
      if (source.src !== initialSrc || source.type !== initialType ||
          player.changingSrc_) return;
      var hls = /^(?:application|audio)\/(?:x-|vnd\.apple\.)?mpegurl$/.test(type) ||
        (!type && /\.m3u8(?:[?#]|$)/i.test(source.src));
      if (!hls || player.currentSources().length > 1) return;
      var tech = player.tech({ IWillNotUseThisInPlugins: true });
      // These two private fields are verified against bundled Video.js 7.20.3.
      // Do not reset existing VHS or any non-native attached source handler.
      if (!tech || tech.vhs || tech.sourceHandler_ ||
          !tech.el || tech.el().nodeName !== 'VIDEO') return;
      // Never interrupt playback, pending play/autoplay, seeking, or a started player.
      // Idle metadata/buffering can be rebound once before first playback.
      if (player.autoplay() || player.waitToPlay_ ||
          (player.playCallbacks_ && player.playCallbacks_.length) ||
          !player.paused() || player.hasStarted() ||
          player.currentTime() !== 0 ||
          player.seeking() || player.ended() ||
          player.played().length) return;
      var bound = Object.assign({}, source);
      if (!bound.type) bound.type = 'application/x-mpegURL';
      player._klaroHlsInitV1 = true;
      player.src(bound); // One initialization binding; no play(), load(), or reset().
      } catch (err) { /* Also isolate errors from an asynchronous ready callback. */ }
    });
  }

  function setupVideos() {
    // Video.js replaces video.video-js with a wrapper and video.vjs-tech.
    // Include both forms or already-auto-initialized players remain invisible.
    var videos = document.querySelectorAll('video.video-js, .video-js video.vjs-tech');
    var needsLibrary = false;
    Array.prototype.forEach.call(videos, function (video) {
      try {
        // The element owns the authoritative player even if window.videojs was
        // replaced by the inline loader's second copy of Video.js.
        var wrapper = video.closest && video.closest('.video-js');
        var player = video.player || (wrapper && wrapper.player);
        if (!player) {
          // Never initialize an orphaned tech element as a second player.
          if (!video.classList.contains('video-js')) return;
          if (!window.videojs) { needsLibrary = true; return; }
          player = window.videojs(video);
        }
        bindInitialHls(player);
      } catch (err) { /* Isolate this video; preserve initialization of others. */ }
    });
    return !needsLibrary;
  }

  // Existing loader/retry schedule is retained; source binding itself is once
  // per player, not a periodic reset, and does not add listeners or timers.
  function loadAndSetup() {
    if (!setupVideos()) {
      var hasLoader = Array.prototype.some.call(document.scripts, function (script) {
        return script.src && script.src.indexOf('vjs.zencdn.net/7.20.3/video.min.js') !== -1;
      });
      if (!hasLoader) {
        var script = document.createElement('script');
        script.src = 'https://vjs.zencdn.net/7.20.3/video.min.js';
        script.onload = setupVideos;
        document.head.appendChild(script);
      }
      var tries = 0, timer = window.setInterval(function () {
        tries += 1;
        if (setupVideos() || tries >= 40) window.clearInterval(timer);
      }, 250);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadAndSetup);
  else loadAndSetup();
  window.setTimeout(loadAndSetup, 1000);
  window.setTimeout(loadAndSetup, 3000);
})();
